import { parseCreditCardToInternalStructure } from 'parsers/creditCardParser/creditCardParser';
import { parseEcheckToInternalStructure } from 'parsers/echeckParser/echeckParser';
import { parseWalletToInternalStructure } from 'parsers/walletParser/walletParser';

/**
 * Parses a payment method object into the internal structure.
 *
 * Returns an object containing billing info, payment method UUID, status,
 * and the parsed credit card, eCheck, and wallet details, along with the payment method type.
 *
 * @param paymentMethod The payment method object to be parsed.
 * @returns The internal structure representation of the payment method.
 */
export const parseToInternalStructure = paymentMethod => ({
  billingInfo: paymentMethod.billingInfo,
  paymentMethodUuid: paymentMethod.paymentMethodUuid,
  status: paymentMethod.status,
  creditCard: parseCreditCardToInternalStructure(paymentMethod),
  echeck: parseEcheckToInternalStructure(paymentMethod),
  wallet: parseWalletToInternalStructure(paymentMethod),
  paymentMethodType: getPaymentMethodType(paymentMethod),
});

const getPaymentMethodType = paymentMethod => {
  if (paymentMethod?.accountType) {
    return 'ECHECK';
  }
  if (paymentMethod?.expirationDate) {
    return 'CREDIT_CARD';
  }
  if (paymentMethod?.walletType) {
    return 'WALLET';
  }
  return '';
};
